import { render, staticRenderFns } from "./SectionNavigationNewV2.vue?vue&type=template&id=65e8cf5e&scoped=true&"
import script from "./SectionNavigationNewV2.vue?vue&type=script&lang=ts&"
export * from "./SectionNavigationNewV2.vue?vue&type=script&lang=ts&"
import style0 from "./SectionNavigationNewV2.vue?vue&type=style&index=0&id=65e8cf5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e8cf5e",
  null
  
)

export default component.exports